import { QueryClient } from "@tanstack/react-query";

// App-wide React Query client. Cache lives here (above the router) so admin
// list/count data survives page navigation instead of being refetched on every
// mount. Conservative, cost-efficient defaults:
//  - staleTime 45s  -> cached reads are reused for ~45s (no refetch on quick
//                      back-and-forth navigation or re-render).
//  - gcTime 5m      -> unused cache is dropped after 5 minutes.
//  - refetchOnWindowFocus false -> no refetch storm when switching browser tabs
//                      (replaces the old manual focus/visibility listeners).
//  - retry 1        -> one quiet retry on transient failure.
// Per-key de-duplication is automatic: identical in-flight requests collapse
// into one, and React Query ignores out-of-order responses for a key so a slow
// older response can never overwrite a newer one.
// NOTE: critical, server-validated operations (payment approve/decline,
// finalize, reopen) are NOT cached — they stay direct apiClient calls, and the
// reads that gate them (e.g. finalize-status) are configured with staleTime 0.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 45_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});
